(ns app.front.view.admin.migration.add-domain-authority-users-as-domain-admins
  (:require [app.front.view.admin.migration.template :as admin-migration-template]
            [core.front.event :refer [>evt]]))

(defn view [match]
  [admin-migration-template/admin-page-for-migration
   {:task-id   :app.admin.migration.task/add-domain-authority-users-as-domain-admins
    :title     "Add authority users for domain groups that are missing one"
    :help-text "Adds selected authority users as domain organizational admins for local-government domain groups that have none.
   Selection matches the WIN-5547 report fallback: prefer users who are authority-group admins in every authority
   group under the domain; otherwise add one deterministic authority user from an authority group."}
   match])

(def route
  {:name        :view/admin.migration.add-domain-authority-users-as-domain-admins
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::admin-migration-template/fetch-migration-tasks
                                  :app.admin.migration.task/add-domain-authority-users-as-domain-admins]))}]})
